import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import EntryLevelLearning from "../src/pages/EntryLevelLearning";
import SecurityLearningFramework from "../src/pages/SecurityLearningFramework";
import KeyInitiatives from "../src/pages/KeyInitiatives";
import LearningHighlights from "../src/pages/LearningHighlights";
import { PageLayout } from "../src/function-components/PageLayout";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import TrainingCalendar from "./function-components/SLFComponents/SecurityCalendar/TrainingCalendarMain";
import CyberHER from "./pages/CyberHER";
import CyberSecurity from "./function-components/CyberSecurity";
import HomeContent from "./function-components/HomeContent";
import SecuritySchools from "../src/pages/SecuritySchools";
import SailPointIdentityIQ from "./function-components/SecuritySchoolsComponents/IdentityManagement/SailPointIdentityIQ";
import Specializations from "./function-components/SLFComponents/Specializations";
import Delivery from "./pages/Delivery";
import Industry from "./function-components/Industry";
import Professional from "./pages/Professional";
import SailPointIdentityNow from "./function-components/SecuritySchoolsComponents/IdentityManagement/SailPointIdentityNowCard";
import SecurityPlatforms from "./function-components/SecuritySchoolsComponents/PlatformSecurity/SalesforceSecurityCard";
import SAPCard from "./function-components/SecuritySchoolsComponents/PlatformSecurity/PlatformSAPCard";
import Tufin from "./function-components/SecuritySchoolsComponents/InfrastructureSecurity/TufinFoundationSchool";
import OracleIM from "./function-components/SecuritySchoolsComponents/IdentityManagement/OracleIdentityManagement";
import OracleIGovernance from "./function-components/SecuritySchoolsComponents/IdentityManagement/OracleIdentityGovernance";
import CyberarkEPM from "./function-components/SecuritySchoolsComponents/IdentityManagement/Cyberark-EPM";
import CyberarkPAM from "./function-components/SecuritySchoolsComponents/IdentityManagement/CyberArkPAM";
import ForgeRock from "./function-components/SecuritySchoolsComponents/IdentityManagement/ForgeRock";
import Calendar from "./function-components/Calendar";

// import SecuritySpecializationTab from "./function-components/SLFComponents/SecuritySpecializationAcademy/SecuritySpecializationTab";
import PhysicalSecurityTab from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/CyberPhysicalSecurity/PhysicalSecurityTab";

// import IntegratedRiskIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/IntegratedRisk/InstructorLead";
// import IRCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/IntegratedRisk/Certification";
// import IRProgressiveLearning from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/IntegratedRisk/ProgressiveLearningPath";
// import IRECOSystem from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/IntegratedRisk/ECO-SystemLearning";

// import CSuiteIntegratedRiskIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/C-Suite-CyberAdvisory/InstructorLead";
// import CSuiteCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/C-Suite-CyberAdvisory/Certification";
// import CSuiteProgressiveLearning from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/C-Suite-CyberAdvisory/ProgressiveLearningPath";
// import CSuiteECOSystem from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/C-Suite-CyberAdvisory/ECO-SystemLearning";

// import CRRInstructorLead from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Regulatory/InstructorLead";
// import CRRCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Regulatory/Certification";
// import CRRProgressiveLearning from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Regulatory/ProgressiveLearningPath";
// import CRRECOSystem from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Regulatory/ECO-SystemLearning";

// import SSOInstructorLead from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/SecurityStrategy-Organization/InstructorLead";
// import SSOCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/SecurityStrategy-Organization/Certification";
// import SSOProgressiveLearning from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/SecurityStrategy-Organization/ProgressiveLearningPath";
// import SSOECOSystem from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/SecurityStrategy-Organization/ECO-SystemLearning";

// import RiskComplianceInstructorLead from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Compliance/InstructorLead";
// import RiskComplianceCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Compliance/Certification";
// import RiskComplianceProgressiveLearning from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Compliance/ProgressiveLearningPath";
// import RiskComplianceECOSystem from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberStrategy/CyberRisk-Compliance/ECO-SystemLearning";

// import CyberDefenseIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberDefense/InstructorLead";
// import CyberDefenseCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberDefense/Certification";
// import CyberDefensePL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberDefense/ProgressiveLearningPath";
// import CyberDefenseECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberDefense/ECO-SystemLearning";

// import CyberResponseIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberResponse/InstructorLead";
// import CyberResponseCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberResponse/Certification";
// import CyberResponsePL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberResponse/ProgressiveLearningPath";
// import CyberResponseECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberResponse/ECO-SystemLearning";

// import CyberIntelligenceIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberIntelligence/InstructorLead";
// import CyberIntelligenceCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberIntelligence/Certification";
// import CyberIntelligencePL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberIntelligence/ProgressiveLearningPath";
// import CyberIntelligenceECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberResilience/CyberIntelligence/ECO-SystemLearning";

// import OperationSecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/OperationSecurity/InstructorLead";
// import OperationSecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/OperationSecurity/Certification";
// import OperationSecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/OperationSecurity/ProgressiveLearningPath";
// import OperationSecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/OperationSecurity/ECO-SystemLearning";

// import ProductSecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/ProductSecurity/InstructorLead";
// import ProductSecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/ProductSecurity/Certification";
// import ProductSecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/ProductSecurity/ProgressiveLearningPath";
// import ProductSecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberPhysicalSecurity/ProductSecurity/ECO-SystemLearning";

// import IdentityAccessIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/IdentityAccessManagement/InstructorLead";
// import IdentityAccessCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/IdentityAccessManagement/Certification";
// import IdentityAccessPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/IdentityAccessManagement/ProgressiveLearningPath";
// import IdentityAccessECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/IdentityAccessManagement/ECO-SystemLearning";

// import ApplicationSecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ApplicationSecurity/InstructorLead";
// import ApplicationSecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ApplicationSecurity/Certification";
// import ApplicationSecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ApplicationSecurity/ProgressiveLearningPath";
// import ApplicationSecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ApplicationSecurity/ECO-SystemLearning";

// import CloudSecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/CloudSecurity/InstructorLead";
// import CloudSecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/CloudSecurity/Certification";
// import CloudSecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/CloudSecurity/ProgressiveLearningPath";
// import CloudSecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/CloudSecurity/ECO-SystemLearning";

// import EmergingTechnologyIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EmergingTechnologySecurity/InstructorLead";
// import EmergingTechnologyCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EmergingTechnologySecurity/Certification";
// import EmergingTechnologyPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EmergingTechnologySecurity/ProgressiveLearningPath";
// import EmergingTechnologyECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EmergingTechnologySecurity/ECO-SystemLearning";

// import EnterprisePlatformSecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EnterprisePlatformSecurity/InstructorLead";
// import EnterprisePlatformSecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EnterprisePlatformSecurity/Certification";
// import EnterprisePlatformSecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EnterprisePlatformSecurity/ProgressiveLearningPath";
// import EnterprisePlatformSecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/EnterprisePlatformSecurity/ECO-SystemLearning";

// import DataAISecurityIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/DataAISecurity/InstructorLead";
// import DataAISecurityCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/DataAISecurity/Certification";
// import DataAISecurityPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/DataAISecurity/ProgressiveLearningPath";
// import DataAISecurityECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/DataAISecurity/ECO-SystemLearning";

// import ZeroTrustIL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ZeroTrust/InstructorLead";
// import ZeroTrustCertification from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ZeroTrust/Certification";
// import ZeroTrustPL from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ZeroTrust/ProgressiveLearningPath";
// import ZeroTrustECO from "./function-components/SLFComponents/SecuritySpecializationAcademy/CyberProtection/ZeroTrust/ECO-SystemLearning";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// new imports
import SecuritySpecialization from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/SecuritySpecialization";
import CyberResilienceTab from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/CyberResilience/CyberResilienceTab";
import CyberStrategyTab from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/CyberStrategy/CyberStrategy";
import CrossOfferingsTab from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/CrossOfferings/CrossOfferingsTab";
import CyberProtectionTab from "./function-components/SLFComponents/SecuritySpecializationAcademyNew/CyberProtection/CyberProtectionTab";

import CrossOffering from "./function-components/CrossOffering";
import EcoSystem from "./function-components/EcoSystemPartners";import AnalyticsPage from "./function-components/AnalyticsPage";
import IndustryTab from "./function-components/IndustryTab";
import Hackathon from "./pages/Hackathon";
import Cyberedge from "./pages/Cyberedge";
;

function App({ pca }) {
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  useEffect(() => {
    console.log("0");
    if (activeAccount) {
      console.log("1");
      fetchAccessToken();
      console.log("2");
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      console.log(bearer);
      localStorage.setItem("token", bearer);
      console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  // for specialization main tab
  const [value, setValue] = React.useState(0);
  const [strategyVal, setStrategyVal] = React.useState("C-Suite-CyberAdvisory");
  const [resVal, setResVal] = React.useState("CyberDefense");
  const [protVal, setProtVal] = React.useState("Identity-AccessManagement");
  const [physicalVal, setPhysicalVal] = React.useState("OperationSecurity");
  const [crossVal, setCrossVal] = React.useState("CCO-CyberStrategy");

  return (
    <>
      <Router>
        <SearchNav />
        <Navbarmenu />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/CyberHER">
            <CyberHER />
          </Route>
          <Route exact path="/Hackathon">
            <Hackathon/>
          </Route>
          <Route exact path="/Cyberedge">
            <Cyberedge/>
          </Route>
          <Route exact path="/home">
            <Home />
          </Route>
          <Route exact path="/AnalyticsPage">
            <AnalyticsPage />
          </Route>
          <Route exact path="/homeContent">
            <HomeContent />
          </Route>
          <Route exact path="/entryLevelLearning">
            <EntryLevelLearning />
          </Route>
          <Route exact path="/delivery">
            <Delivery />
          </Route>
          <Route exact path="/industryTab">
            <IndustryTab/>
          </Route>
          
          <Route exact path="/securityLearningFramework">
            <SecurityLearningFramework />
          </Route>
          <Route exact path="/keyInitiatives">
            <KeyInitiatives />
          </Route>
          <Route exact path="/CrossOffering">
            <CrossOffering />
          </Route>
          <Route exact path="/EcoSystem">
            <EcoSystem />
          </Route>
          <Route exact path="/learningHighlights">
            <LearningHighlights />
          </Route>
          <Route exact path="/securityTrainingCalendar">
            <TrainingCalendar />
          </Route>
          <Route exact path="/securitySchools">
            <SecuritySchools />
          </Route>
          <Route exact path="/cyberSecurity">
            <CyberSecurity />
          </Route>
          <Route exact path="/SailPointIdentityIQ">
            <SailPointIdentityIQ />
          </Route>
          <Route exact path="/specializations">
            <Specializations />
          </Route>
          <Route exact path="/industry">
            <Industry />
          </Route>
          <Route exact path="/professional">
            <Professional />
          </Route>
          <Route exact path="/SailPointIdentityNow">
            <SailPointIdentityNow />
          </Route>
          <Route exact path="/OracleIdentityManagement​​​s">
            <OracleIM />
          </Route>
          <Route exact path="/OracleIdentityGovernance">
            <OracleIGovernance />
          </Route>
          <Route exact path="/CyberarkEPM">
            <CyberarkEPM />
          </Route>
          <Route exact path="/CyberarkPAM">
            <CyberarkPAM />
          </Route>
          <Route exact path="/Forgerock">
            <ForgeRock />
          </Route>
          <Route exact path="/Tufin">
            <Tufin />
          </Route>
          <Route exact path="/SecurityPlatforms">
            <SecurityPlatforms />
          </Route>
          <Route exact path="/SAPSecurity">
            <SAPCard />
          </Route>

          <Route exact path="/CyberPhysicalSecurityNew">
            <PhysicalSecurityTab />
          </Route>
          <Route exact path="/CyberResilienceNew">
            <CyberResilienceTab />
          </Route>
          <Route exact path="/CyberStrategyNew">
            <CyberStrategyTab />
          </Route>
          <Route exact path="/CrossOfferingsNew">
            <CrossOfferingsTab />
          </Route>
          <Route exact path="/CyberProtectionNew">
            <CyberProtectionTab />
          </Route>

          {/* <Route exact path="/SecuritySpecializationAcademy">
            <SecuritySpecializationTab
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/IntegratedRiskInstructorLead">
            <IntegratedRiskIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IntegratedRiskCertification">
            <IRCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IntegratedRiskProgressiveLearning">
            <IRProgressiveLearning
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IntegratedRiskECOLearning">
            <IRECOSystem
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/C-SuiteCyberAdvisoryInstructorLead">
            <CSuiteIntegratedRiskIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/C-SuiteCyberAdvisoryCertification">
            <CSuiteCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/C-SuiteCyberAdvisoryProgressiveLearning">
            <CSuiteProgressiveLearning
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
          {/* <Route exact path="/C-SuiteCyberAdvisoryECOLearning">
            <CSuiteECOSystem
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/CyberRisk-RegulatoryInstructorLead">
            <CRRInstructorLead
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-RegulatoryCertification">
            <CRRCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-RegulatoryProgressiveLearning">
            <CRRProgressiveLearning
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-RegulatoryECOLearning">
            <CRRECOSystem
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/SecurityStrategy-OrganizationInstructorLead">
            <SSOInstructorLead
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/SecurityStrategy-OrganizationCertification">
            <SSOCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/SecurityStrategy-OrganizationProgressiveLearning">
            <SSOProgressiveLearning
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/SecurityStrategy-OrganizationECOLearning">
            <SSOECOSystem
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/CyberRisk-ComplianceInstructorLead">
            <RiskComplianceInstructorLead
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-ComplianceCertification">
            <RiskComplianceCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-ComplianceProgressiveLearning">
            <RiskComplianceProgressiveLearning
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberRisk-ComplianceECOLearning">
            <RiskComplianceECOSystem
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
{/* 
          <Route exact path="/CyberDefenseInstructorLead">
            <CyberDefenseIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberDefenseCertification">
            <CyberDefenseCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberDefenseProgressiveLearning">
            <CyberDefensePL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberDefenseECOLearning">
            <CyberDefenseECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/CyberResponseInstructorLead">
            <CyberResponseIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberResponseCertification">
            <CyberResponseCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberResponseProgressiveLearning">
            <CyberResponsePL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberResponseECOLearning">
            <CyberResponseECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/CyberIntelligenceInstructorLead">
            <CyberIntelligenceIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberIntelligenceCertification">
            <CyberIntelligenceCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberIntelligenceProgressiveLearning">
            <CyberIntelligencePL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CyberIntelligenceECOLearning">
            <CyberIntelligenceECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/OperationSecurityInstructorLead">
            <OperationSecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/OperationSecurityCertification">
            <OperationSecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/OperationSecurityProgressiveLearning">
            <OperationSecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/OperationSecurityECOLearning">
            <OperationSecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/ProductSecurityInstructorLead">
            <ProductSecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ProductSecurityCertification">
            <ProductSecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ProductSecurityProgressiveLearning">
            <ProductSecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ProductSecurityECOLearning">
            <ProductSecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/IdentityAccessInstructorLead">
            <IdentityAccessIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IdentityAccessCertification">
            <IdentityAccessCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IdentityAccessProgressiveLearning">
            <IdentityAccessPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/IdentityAccessECOLearning">
            <IdentityAccessECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/ApplicationSecurityInstructorLead">
            <ApplicationSecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ApplicationSecurityCertification">
            <ApplicationSecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ApplicationSecurityProgressiveLearning">
            <ApplicationSecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ApplicationSecurityECOLearning">
            <ApplicationSecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/CloudSecurityInstructorLead">
            <CloudSecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CloudSecurityCertification">
            <CloudSecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CloudSecurityProgressiveLearning">
            <CloudSecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/CloudSecurityECOLearning">
            <CloudSecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
{/* 
          <Route exact path="/EnterprisePlatformSecurityInstructorLead">
            <EnterprisePlatformSecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/EnterprisePlatformSecurityCertification">
            <EnterprisePlatformSecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/EnterprisePlatformSecurityProgressiveLearning">
            <EnterprisePlatformSecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/EnterprisePlatformSecurityECOLearning">
            <EnterprisePlatformSecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/DataAISecurityInstructorLead">
            <DataAISecurityIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/DataAISecurityCertification">
            <DataAISecurityCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/DataAISecurityProgressiveLearning">
            <DataAISecurityPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/DataAISecurityECOLearning">
            <DataAISecurityECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>

          <Route exact path="/ZeroTrustInstructorLead">
            <ZeroTrustIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ZeroTrustCertification">
            <ZeroTrustCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ZeroTrustProgressiveLearning">
            <ZeroTrustPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route>
          <Route exact path="/ZeroTrustECOLearning">
            <ZeroTrustECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* <Route exact path="/EmergingTechnologyInstructorLead">
            <EmergingTechnologyIL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
          {/* <Route exact path="/EmergingTechnologyCertification">
            <EmergingTechnologyCertification
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
          {/* <Route exact path="/EmergingTechnologyProgressiveLearning">
            <EmergingTechnologyPL
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}
          {/* <Route exact path="/EmergingTechnologyECOLearning">
            <EmergingTechnologyECO
              value={value}
              setValue={setValue}
              strategyVal={strategyVal}
              setStrategyVal={setStrategyVal}
              resVal={resVal}
              setResVal={setResVal}
              protVal={protVal}
              setProtVal={setProtVal}
              physicalVal={physicalVal}
              setPhysicalVal={setPhysicalVal}
              crossVal={crossVal}
              setCrossVal={setCrossVal}
            />
          </Route> */}

          {/* New calendar  */}
          <Route exact path="/Calendar">
            <Calendar />
          </Route>

          {/* New Components for Security Specialization as per new design  */}
          <Route exact path="/SecuritySpecializationAcademyNew">
            <SecuritySpecialization />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
